/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Open_SettingsInputs */



/**
* | output |
* | --- |
* | "Open Live Captioning settings" |
*
* @param {Live_Caption_Open_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_open_settings = /** @type {((inputs?: Live_Caption_Open_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Open_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir les paramètres de sous-titrage en direct")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen für Live-Untertitelung öffnen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri le impostazioni dei sottotitoli in tempo reale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыть настройки субтитров в реальном времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Abrir la configuración de subtítulos en directo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("打开实时字幕设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ライブキャプション設定を開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइव कैप्शनिंग सेटिंग्स खोलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Abra as configurações de Legendas ao Vivo.")
	return /** @type {LocalizedString} */ ("Open Live Captioning settings")
});